/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import Table from "../table/Table.js";
import {getAll} from "../../../backend/read/GetAll";
import {ACCESS_TOKEN_KEY} from "../../../utilities/Constants";
import {decodeToken} from "../../../utilities/auth/Introspect";

class PartList extends React.Component {

    constructor(props) {
        super(props);
        const admin = decodeToken(JSON.parse(sessionStorage.getItem(ACCESS_TOKEN_KEY))).admin;
        this.state = {
            data: [],
            cols: [
                {"name": "MPN", "attributeName": "PART_ID", "filter": true, "checkboxFilter": false},
                {"name": "Effectivity", "attributeName":  "EFFECTIVITY_ID", "filter": true, "checkboxFilter": false},
                {"name": "ATA", "attributeName":  "ATA", "filter": true, "checkboxFilter": false},
                {"name": "Vendor", "attributeName":  "VENDOR", "filter": true, "checkboxFilter": false},
                {"name": "Part Type", "attributeName":  "PART_TYPE_CODE", "filter": true, "checkboxFilter": true,
                    "checkboxTitleOne": "WHEEL", "checkboxTitleTwo": "BRAKE"},
                {"name": "Status", "attributeName":  "ACTIVE_FLAG", "filter": true, "checkboxFilter": true,
                    "checkboxTitleOne": "ACTIVE", "checkboxTitleTwo": "INACTIVE"},
                {"name": "Last Updated (UTC)", "attributeName":  "LAST_UPDATED_TIMESTAMP", "filter": false}
            ],
            button: {"name": "Edit", "hide": !admin, "path": "/edit-part"},
            defaultSort: {"ACTIVE_FLAG": "asc", "PART_ID": "asc"}
        };
    }

    componentDidMount() {
        getAll("PARTS").then(r => {
            let temp = [];
            JSON.parse(r.body.data).Items.forEach(element => {
                let tempElement = element;
                tempElement.PART_ID = element.PART_ID;
                tempElement.ATA = element.ATA;
                tempElement.VENDOR = element.VENDOR;
                tempElement.PART_TYPE_CODE = element.PART_TYPE_CODE;
                let timestamp = new Date(0);
                timestamp.setUTCMilliseconds(element.LAST_UPDATED_TIMESTAMP);
                tempElement.LAST_UPDATED_TIMESTAMP = timestamp.toLocaleString('en-US', {hour12: false, timeZone: 'UTC'});
                if ( element.ACTIVE_FLAG === true ) {
                    tempElement.ACTIVE_FLAG = "ACTIVE";
                }
                else {
                    tempElement.ACTIVE_FLAG = "INACTIVE";
                }
                let activeIndex = temp.findIndex(part => {
                    return part.PART_ID === tempElement.PART_ID && part.ACTIVE_FLAG === "ACTIVE"
                });
                let inactiveIndex = temp.findIndex(part => {
                    return part.PART_ID === tempElement.PART_ID && part.ACTIVE_FLAG === "INACTIVE"
                });
                if (activeIndex !== -1 && tempElement.ACTIVE_FLAG === "ACTIVE") {
                    temp[activeIndex].EFFECTIVITY_ID = temp[activeIndex].EFFECTIVITY_ID + ", "  + element.EFFECTIVITY_ID
                } else if (inactiveIndex !== -1 && tempElement.ACTIVE_FLAG === "INACTIVE") {
                    temp[inactiveIndex].EFFECTIVITY_ID = temp[inactiveIndex].EFFECTIVITY_ID + ", " + element.EFFECTIVITY_ID
                } else {
                    tempElement.EFFECTIVITY_ID = element.EFFECTIVITY_ID;
                    temp.push(tempElement);
                }
            });
            this.setState({data: temp})
        })
    }

    render() {
        return (
            <div>
                <div className="list-header">
                    <h2>Manage Parts</h2>
                </div>
                <Table data={this.state.data} cols={this.state.cols} button = {this.state.button}
                       defaultSort={this.state.defaultSort}/>
            </div>
        );
    }
}

export default PartList;
